import Game from "./Game";
import { createCharacterAnims } from "../anims/CharacterAnims";
import "../characters/MyPlayer";
import "../characters/OtherPlayer";
import OtherPlayer from "../characters/OtherPlayer";
import PlayerSelector from "../characters/PlayerSelector";
import Network from "../services/Network";
import store from "../state";
import { setLevel } from "../state/ChatStore";
import Microbiologist from "../items/npc/Microbiologist";
import LabScientist from "../items/npc/LabScientist";
import { NpcMicrobiologist } from "../gameobjects/NpcMicrobiologist";
import { NpcLabScientist } from "../gameobjects/NpcLabScientist";
import { MAP_CONTENT_KEYS } from "../constants/map-content-keys";
import { MAPS } from "../constants/maps";
import { Levels } from "../constants/levels";
import { SCENES } from "../constants/scenes";
import { removeIdList, setLocationz, setPlayerX, setPlayerY } from "../state/UserStore";

export default class ThirdLevel extends Game {
  constructor() {
    super(SCENES.THIRD_LEVEL, MAPS.thirdLevel.key);
  }

  protected init(data: any) {
    this.createLayer(data);
    this.physics.world.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);

    const levelRightCorridor = this.map.objects.find((o) => o.name === MAP_CONTENT_KEYS.objects.ZONES_CORRIDOR_RIGHT);
    if (levelRightCorridor) {
      levelRightCorridor.objects.map((o: any) => {
        const zone = this.add.zone(o.x, o.y, o.width, o.height);
        this.physics.add.existing(zone);
        this.physics.add.overlap(zone, this.playerSelector, () => {
          if (o.properties[3].value === MAP_CONTENT_KEYS.objects.ZONES_CORRIDOR_RIGHT) {
            store.dispatch(setPlayerX(7000));
            store.dispatch(setPlayerY(8500));
          } else {
            store.dispatch(setPlayerX(1000));
            store.dispatch(setPlayerY(6900));
          }

          this.scene.start(o.properties[1].value, {
            comesFrom: this.scene.key,
            network: this.network,
          });
        });
      });
    }

    // this.createAudio();
    this.initCamera();
    this.registerKeys();
  }

  createLayer(data: { network: Network }) {
    if (!data.network) {
      throw new Error("server instance missing");
    } else {
      this.network = data.network;
    }

    createCharacterAnims(this.anims);

    this.map = this.make.tilemap({ key: this.mapKey });
    store.dispatch(setLevel(SCENES.THIRD_LEVEL));
    store.dispatch(removeIdList());

    store.dispatch(setLocationz(3));

    const dataState = store.getState().userGame;
    this.myPlayer = this.add.myPlayer(550, 2900, dataState.textureName ? dataState.textureName : "male", this.network.mySessionId);

    Levels.thirdLevel.layers.map((layer) => {
      const tilesetImage = this.map.addTilesetImage(layer.tilesetImage.tilesetName, layer.tilesetImage.tilesetKey);

      const newLayer = this.map.createLayer(layer.layerName, tilesetImage);
      newLayer.setCollisionByProperty({ collides: layer.collision });
      this.physics.add.collider([this.myPlayer, this.myPlayer.playerContainer], newLayer);
    });

    this.playerSelector = new PlayerSelector(this, 0, 0, 256, 512);

    // don't go out of the map
    this.physics.world.bounds.width = this.map.widthInPixels;
    this.physics.world.bounds.height = this.map.heightInPixels;
    this.myPlayer.setCollideWorldBounds(true);

    // ---- NPC ----
    const microBiologists = this.physics.add.staticGroup({
      classType: Microbiologist,
    });

    const microBiologistsLayer = this.map.getObjectLayer("NPC");
    microBiologistsLayer.objects.forEach((obj, i) => {
      if (obj.name === "Microbiologist") {
        const item = this.addObjectFromPoint(microBiologists, obj, "microbiologist", "Microbiologist") as Microbiologist;
        const id = `${i}`;
        item.id = id;
        this.microBiologistsMap.set(id, item);
      }
    });

    this.npcMicrobiologist.map((npc: NpcMicrobiologist) => {
      this.physics.add.collider(npc, this.myPlayer, npc.talk);
    });

    const labScientists = this.physics.add.staticGroup({
      classType: LabScientist,
    });

    const labScientistLayer = this.map.getObjectLayer("NPC");
    labScientistLayer.objects.forEach((obj, i) => {
      if (obj.name === "LabScientist") {
        const item = this.addObjectFromPoint(labScientists, obj, "labscientist", "LabScientist") as LabScientist;
        const id = `${i}`;
        item.id = id;
        this.labScientistMap.set(id, item);
      }
    });

    this.npcLabScientist.map((npc: NpcLabScientist) => {
      this.physics.add.collider(npc, this.myPlayer, npc.talk);
    });

    this.physics.add.overlap(this.playerSelector, [microBiologists, labScientists], this.handleItemSelectorOverlap, undefined, this);
    // [microBiologists, etc],
    // ---- NPC ----

    // import other objects from Tiled map to Phaser -> use object
    Levels.thirdLevel.tiles.map((tile) => {
      this.addGroupFromTiled(tile.objectLayerName, tile.key, tile.tilesetName, tile.collidable);
    });

    this.otherPlayers = this.physics.add.group({ classType: OtherPlayer });
    for (const key in store.getState().userGame.playerLocMap) {
      console.log(store.getState().userGame.playerLocMap[key], "LOG");
      if (store.getState().userGame.playerLocMap[key].locationz == store.getState().userGame.locationz) {
        const otherPlayer = this.add.otherPlayer(
          store.getState().userGame.playerLocMap[key].x,
          store.getState().userGame.playerLocMap[key].y,
          store.getState().userGame.playerLocMap[key].anim.split("_")[0] ? store.getState().userGame.playerLocMap[key].anim.split("_")[0] : "male",
          store.getState().userGame.playerLocMap[key].id,
          store.getState().userGame.playerLocMap[key].name
        );
        this.otherPlayers.add(otherPlayer);
        this.otherPlayerMap.set(store.getState().userGame.playerLocMap[key].id, otherPlayer);
      }
    }

    this.physics.add.overlap(this.myPlayer, this.otherPlayers, this.handlePlayersOverlap, undefined, this);

    // register network event listeners
    this.network.onPlayerJoinedScene3(this.handlePlayerJoined, this);
    this.network.onPlayerLeft(this.handlePlayerLeft, this);
    this.network.onMyPlayerReady(this.handleMyPlayerReady, this);
    this.network.onMyPlayerVideoConnected(this.handleMyVideoConnected, this);
    this.network.onPlayerUpdated3(this.handlePlayerUpdated, this);
    this.network.onItemUserAdded(this.handleItemUserAdded, this);
    this.network.onItemUserRemoved(this.handleItemUserRemoved, this);
    this.network.onChatMessageAdded(this.handleChatMessageAdded, this);
  }
}
